<template>
  <div
    class="help-center-modal"
    :class="{ 'help-center-modal--active': opened }"
  >
    <button
      class="help-center-modal__close-button"
      @click="closeModal"
    >
      <svg
        class="icon"
        viewBox="0 0 24 24"
      >
        <title>Fechar Modal de Ajuda</title>
        <g
          fill="none"
          stroke="currentColor"
          stroke-miterlimit="10"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line
            x1="3"
            y1="3"
            x2="21"
            y2="21"
          />
          <line
            x1="21"
            y1="3"
            x2="3"
            y2="21"
          />
        </g>
      </svg>
    </button>

    <video
      ref="videoTutorial"
      src="https://storageapoiob2bprd.blob.core.windows.net/dashboard/TREINAMENTO AOL 2.0.mp4"
      controls
    >
      Seu navegador não suporta Tag de Videos. :(
    </video>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DashboardInfoModal',
  props: {
    opened: {
      required: true
    }
  },
  data: () => {
    return {
      firstTimeAtNewDashboard: false
    }
  },
  computed: {
    ...mapGetters(['profile'])
  },
  mounted () {
    this.$refs.videoTutorial.addEventListener('play', this.play)
  },
  beforeDestroy () {
    this.$refs.videoTutorial.addEventListener('play', this.play)
  },
  methods: {
    pushEventToAnalytics (action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Central de Ajuda',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    closeModal () {
      this.$emit('closeModal')
      this.$refs.videoTutorial.pause()
      this.$refs.videoTutorial.currentTime = 0
    },
    play () {
      this.pushEventToAnalytics('Ajudar básica - Play Video')
    }
  }
}
</script>

<style lang="scss">
.help-center-modal {
  position: fixed;
  z-index: 1040;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  visibility: hidden;
  background-color: rgba(0, 0, 0, 0.92);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity ease-in 0.2s;

  &--active {
    opacity: 1;
    visibility: visible;
  }

  &__close-button {
    width: 40px;
    height: 40px;
    position: fixed;
    top: 30px;
    right: 30px;
    z-index: 1041;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    flex-shrink: 0;
    border-radius: 50%;
    outline: none;
    transition: all ease 0.2s;
    padding: 0;

    svg {
      display: block;
      margin: auto;
      width: 20px;
    }
  }

  video {
    height: auto;
    width: 100%;
    max-width: 980px;
  }
}
</style>
